import { render, staticRenderFns } from "./RemandInfo.vue?vue&type=template&id=7bd8711a&"
import script from "./RemandInfo.vue?vue&type=script&lang=ts&"
export * from "./RemandInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports